// Match schema to CSS spec (use AI to manage)
// Omit less common units like vmin, vmax, pt, pc, in, cm, mm
// Omit normal and inherit values
export const CSS_LENGTH_UNITS = [ 'px', 'em', 'rem', 'vh', 'vw' ] as const;

export const cssNumber = /^-?\d*\.?\d+$/;
// eslint-disable-next-line security/detect-non-literal-regexp
export const cssLength = new RegExp(`^-?\\d*\\.?\\d+(${ CSS_LENGTH_UNITS.join('|') })$`);
export const cssPercentage = /^-?\d*\.?\d+%$/;
export const borderRegex = /^\d+(px|em|rem|%)?\s+(solid|dashed|dotted|double|groove|ridge|inset|outset)\s+([A-Za-z]+|#[\dA-Fa-f]{6}|#[\dA-Fa-f]{3})$/;
export const AUTO = 'auto';

export enum TEXT_TRANSFORM {
    CAPITALIZE = 'capitalize',
    UPPERCASE = 'uppercase',
    LOWERCASE = 'lowercase',
    NONE = 'none'
}

export enum FONT_WEIGHT {
    _100 = '100',
    _200 = '200',
    _300 = '300',
    _400 = '400',
    _500 = '500',
    _600 = '600',
    _700 = '700',
    _800 = '800',
    _900 = '900',
    NORMAL = 'normal',
    BOLD = 'bold'
}

export enum FONT_STYLE {
    NORMAL = 'normal',
    ITALIC = 'italic'
}

export enum DISPLAY {
    BLOCK = 'block',
    INLINE = 'inline',
    INLINE_BLOCK = 'inline-block',
    FLEX = 'flex',
    NONE = 'none'
}

export enum FLEX_DIRECTION {
    ROW = 'row',
    COLUMN = 'column',
    ROW_REVERSE = 'row-reverse',
    COLUMN_REVERSE = 'column-reverse'
}

export enum JUSTIFY_CONTENT {
    START = 'flex-start',
    END = 'flex-end',
    CENTER = 'center',
    BETWEEN = 'space-between',
    AROUND = 'space-around',
    EVENLY = 'space-evenly'
}

export enum ALIGN_ITEMS {
    START = 'flex-start',
    END = 'flex-end',
    CENTER = 'center',
    BASELINE = 'baseline',
    STRETCH = 'stretch'
}

export enum TEXT_ALIGN {
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right',
    JUSTIFY = 'justify'
}

export enum POSITION {
    STATIC = 'static',
    RELATIVE = 'relative',
    ABSOLUTE = 'absolute',
    FIXED = 'fixed',
    STICKY = 'sticky'
}

export enum OBJECT_FIT {
    CONTAIN = 'contain',
    COVER = 'cover',
    FILL = 'fill',
    NONE = 'none',
    SCALE_DOWN = 'scale-down'
}

export enum BORDER_STYLE {
    SOLID = 'solid',
    DASHED = 'dashed',
    DOTTED = 'dotted',
    DOUBLE = 'double',
    GROOVE = 'groove',
    RIDGE = 'ridge',
    INSET = 'inset',
    OUTSET = 'outset'
}
